// extracted by mini-css-extract-plugin
export default {"root":"QuoteItem__root--Ep0KK","left":"QuoteItem__left--Lkp6G","row-title":"QuoteItem__row-title--U0zTO","rowTitle":"QuoteItem__row-title--U0zTO","right":"QuoteItem__right--KqvIT"};